import { HashLink as Link } from "react-router-hash-link";
import { useScrollSpy } from "../../hooks/useScrollSpy";
import { useScrollToSection } from "../../hooks/useScrollToSection";
import { AutodocSection } from "./AutodocSection";
import { CustomizingSection } from "./CustomizingSection";
import { NavButton } from "./NavButton";
import { StepsSection } from "./StepsSection";
import { SupportSection } from "./SupportSection";
import { TrainingSection } from "./TrainingSection";
import { TroubleshootingSection } from "./Troubleshooting";
import { TutorialButton } from "./TutorialButton";
import styles from "./Tutorials.module.scss";
import { useOfficeHoursCountdown } from "./useOfficeHoursCountdown";
import { VideosSection } from "./VideosSection";

export default function Tutorials() {
  useOfficeHoursCountdown();

  // Define section IDs in order of appearance
  const sectionIds = [
    "training",
    "support",
    "videos",
    "steps",
    "autodoc",
    "customizing",
    "troubleshooting",
  ];
  const activeSection = useScrollSpy({ sectionIds, offset: -150 });

  // Scroll to section on page load when hash is present in URL
  useScrollToSection({
    sectionIds,
    offsetPx: 65,
  });

  return (
    <section className={styles.bpWrap} id="briefpoint-tutorials">
      <div className={styles.container}>
        {/* Hero */}
        <div className={styles.hero}>
          <span className={styles.badge}>
            <span className={styles.dot} />
            Tutorials
          </span>
          <h1 data-testid="tutorials-header">How-To Briefpoint</h1>
          <p className="lead">
            Quick links, short videos, and step-by-step guides to help your team
            get value from Briefpoint fast.
          </p>
          <div className={styles.btnRow} style={{ marginTop: "14px" }}>
            <TutorialButton
              size="lg"
              variant="primary"
              to="https://calendly.com/briefpointceo/briefpoint-overview"
              offsite
            >
              Schedule Training
            </TutorialButton>
            <TutorialButton to="#videos" size="lg" variant="outline">
              Watch Video Instructions
            </TutorialButton>
          </div>
        </div>

        {/* Top nav */}
        <nav className={styles.tabs} aria-label="Section navigation">
          <NavButton
            to="#training"
            isActive={activeSection === "training" || (!activeSection && true)}
          >
            Training
          </NavButton>
          <NavButton to="#support" isActive={activeSection === "support"}>
            Support
          </NavButton>
          <NavButton to="#videos" isActive={activeSection === "videos"}>
            Videos
          </NavButton>
          <NavButton to="#steps" isActive={activeSection === "steps"}>
            Step-by-Step
          </NavButton>
          <NavButton to="#autodoc" isActive={activeSection === "autodoc"}>
            Autodoc
          </NavButton>
          <NavButton
            to="#customizing"
            isActive={activeSection === "customizing"}
          >
            Customizing
          </NavButton>
          <NavButton
            to="#troubleshooting"
            isActive={activeSection === "troubleshooting"}
          >
            Troubleshooting
          </NavButton>
        </nav>

        <TrainingSection />

        <SupportSection />

        <VideosSection />

        <StepsSection />

        <AutodocSection />

        <CustomizingSection />

        <TroubleshootingSection />

        <div className={styles.foot}>
          © Briefpoint — Purpose-built for litigation teams. ·{" "}
          <Link to="#briefpoint-tutorials" smooth>
            Back to top
          </Link>
        </div>
      </div>
    </section>
  );
}
